<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-dialog
      class="newDialog"
      title="傳送待付款訊息給客戶"
      :visible.sync="visible"
      height="100%"
      :before-close="handleClose"
    >
      <div class="newList">
        <ul class="noNext" v-if="contractList.length > 0">
          <div
            v-loading.fullscreen.lock="fullscreenLoading"
            v-for="(contract, contractIndex) in contractList"
            :key="contractIndex"
          >
            <li
              class="withoutImg"
              v-for="(detail, detailIndex) in contract.OrderDetails"
              :key="detailIndex"
            >
              <span @click="sendContractOrderDetailMessage(contract, detail)"
                >{{ contract.Sn }} - {{ contract.ProductName }} -
                {{ detail.Amount }}元</span
              >
            </li>
          </div>
        </ul>
        <br />
        <span v-if="contractList.length == 0">沒有需要付款的合約</span>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import Global from "@/components/Global";
export default {
  name: "PaymentMessage",
  props: ["roomInfo", "staffInfo"],
  data() {
    return {
      fullscreenLoading: false,
      visible: false,
      contractList: [],
    };
  },
  created() {},
  methods: {
    iniData() {
      this.fullscreenLoading = true;
      jQuery.ajax({
        url: this.$conf.MessageAPI + "/Contract/GetContractOrderDetail",
        type: "post",
        cache: false,
        async: true,
        timeout: 60000,
        data: {
          socialLeadId: this.roomInfo.SocialLeadId,
          staffId: this.staffInfo.StaffID
        },
        dataType: "json",
        success: function (data) {
          this.fullscreenLoading = false;
          if (data.Success) {
            this.contractList = data.Result;
            this.visible = true;
          } else {
            alert(data.ErrorMessage);
          }
        }.bind(this),
        error: function (error) {
          this.fullscreenLoading = false;
          alert(error.statusText);
        }.bind(this),
      });
    },
    handleClose(done) {
      done();
    },
    sendContractOrderDetailMessage(contract, detail) {
      if (
        !confirm(
          "傳送【" +
            contract.ProductName +
            " - " +
            detail.Amount +
            "元】付款訊息給客戶，確定嗎?"
        )
      ) {
        return;
      }

      this.fullscreenLoading = true;

      jQuery.ajax({
        url: this.$conf.MessageAPI + "/Contract/SendContractOrderDetailMessage",
        type: "post",
        cache: false,
        async: true,
        timeout: 60000,
        data: {
          staffId: this.staffInfo.StaffID,
          chatRoomId: this.roomInfo.RoomId,
          clientSn: contract.ClientSn,
          detailSn: detail.DetailSn,
          leadSn: contract.LeadSn,
        },
        dataType: "json",
        success: function (data) {
          this.fullscreenLoading = false;
          if (data.Success) {
            this.visible = false;
          } else {
            alert(data.ErrorMessage);
          }
        }.bind(this),
        error: function (error) {
          this.fullscreenLoading = false;
          alert(error.statusText);
        }.bind(this),
      });
    },
  },
};
</script>

<style>
.gray {
  -webkit-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
  filter: alpha(opacity = 30);
  opacity: 0.3;
}
.withoutImg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  cursor: pointer;
}

.withoutImg span {
  flex: 1;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/ChatToolBar_PaymentMessage.vue